import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import Template from './Template'

import Home from './pages/Home'
import Voucher from './pages/Voucher'

class App extends Component {
  componentWillMount() {
    //T.handleUpdate( () => this.forceUpdate() )
  }

  render() {
    return (
      <Switch>
          <Route exact path="/voucher/:token" render={context => (
            <Template voucher>
              <Voucher { ...context } />
            </Template>
          )} />
          <Route exact path="/:token" render={context => (
            <Template>
              <Home { ...context } />
            </Template>
          )} />
          <Route render={() => {
            window.location.href = window.NOTFOUND
          }}/>
        </Switch>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/index.js